import type { ReactElement } from 'react';
import { Icon } from './Icon';

/**
 * Ein leerer Zustand, der etwas sagt und einen Knopf hat (7.17).
 *
 * „Leere Zustände, die etwas sagen und einen Knopf haben, statt eines grauen
 * Kastens“ (Sascha, 4. September). Der Unterschied ist nicht die Verzierung,
 * sondern die Frage, die dort beantwortet wird: nicht *dass* hier nichts ist
 * -- das sieht man --, sondern **was man jetzt tut**. Ein leerer Bildschirm
 * ohne Weg ist der Ort, an dem Leute aufhören.
 *
 * Der Knopf ist deshalb keine Zierde und auch nicht immer da: wo es wirklich
 * nichts zu tun gibt (ein Verlauf ohne Schritte), steht nur der Satz. Ein
 * Knopf, der nichts Sinnvolles tut, ist schlechter als keiner.
 */
export function LeererZustand({
  zeichen = 'film',
  satz,
  dazu,
  knopf,
  kennung,
}: {
  /** Ein Symbol aus unserem Satz -- nie ein Zeichen aus dem Text. */
  zeichen?: string;
  satz: string;
  /** Der Nebensatz: was das bedeutet, oder was als Nächstes kommt. */
  dazu?: string;
  knopf?: { text: string; onClick: () => void };
  kennung?: string;
}): ReactElement {
  return (
    <div className="leerer-zustand" data-leer={kennung}>
      <span className="leer-zeichen" aria-hidden="true">
        <Icon name={zeichen} size={26} />
      </span>
      <p className="leer-satz">{satz}</p>
      {dazu ? <p className="leer-dazu">{dazu}</p> : null}
      {knopf ? (
        <button className="primary" onClick={knopf.onClick} data-leer-knopf>
          {knopf.text}
        </button>
      ) : null}
    </div>
  );
}
